module.exports = __webpack_public_path__ + "static/media/success.37c6455f.svg";